import {Vue, Component, Watch} from 'vue-property-decorator'

@Component({
    name: 'home',
})
export default class Home extends Vue {
    supplierName:string = '';

    searchForSupplier() {
        if (this.supplierName.length) {
            this.$store.commit('search/setCurrentStageNumber', 0);
            console.log('goto : search/'+this.supplierName)
            this.$router.push({path: "search/" + this.supplierName});
            //this.$router.push({path: "search", query: {supplier_name: this.supplierName}})
        }
    }
}